module.exports = __webpack_public_path__ + "static/media/positionx2.4f35ff13.png";